"use client";

import PropTypes from "prop-types";
import { useState } from "react";
import codeBlocks from "config/api/generated/code-blocks";

export default function MDXPre({ title, raw, children, ...props }) {
  const [isCopied, setIsCopied] = useState(false);
  const languageId = props["data-language"] || "shell";

  const handleCopy = async () => {
    await navigator.clipboard.writeText(raw);
    setIsCopied(true);

    setTimeout(() => {
      setIsCopied(false);
    }, 2000);
  };

  return (
    <div className="relative" data-rehype-pretty-code-fragment>
      <div className="group-[.code-header-hidden]:hidden absolute top-0 inset-x-0 bg-gray-800 text-white rounded-t-lg overflow-hidden">
        <div className="flex items-center justify-between pr-4 font-mono text-sm">
          <div className="h-10">
            <div className="group-[.is-code-tabs]:hidden flex items-center h-10 px-4 sm:px-6 bg-gray-900">
              {title || codeBlocks[languageId] || languageId}
            </div>
          </div>
          <div className="flex items-center">
            {isCopied && <span>Copied!</span>}

            <button
              disabled={isCopied}
              onClick={handleCopy}
              className="group/svg group-[.is-code-tabs]:invisible sm:group-[.is-code-tabs]:visible w-6 h-6 pr-1 -mr-1 flex justify-end items-center hover:cursor-pointer"
            >
              <svg
                width="13"
                height="15"
                viewBox="0 0 13 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  className="transition group-hover/svg:fill-white"
                  d="M8.75 13H4.15625C3.30859 13 2.625 12.3164 2.625 11.4688V3.375H0.65625C0.273438 3.375 0 3.67578 0 4.03125V14.0938C0 14.4766 0.273438 14.75 0.65625 14.75H8.09375C8.44922 14.75 8.75 14.4766 8.75 14.0938V13ZM8.75 3.59375V0.75H4.15625C3.77344 0.75 3.5 1.05078 3.5 1.40625V11.4688C3.5 11.8516 3.77344 12.125 4.15625 12.125H11.5938C11.9492 12.125 12.25 11.8516 12.25 11.4688V4.25H9.40625C9.02344 4.25 8.75 3.97656 8.75 3.59375ZM12.0312 2.74609L10.2539 0.96875C10.1172 0.832031 9.95312 0.75 9.78906 0.75H9.625V3.375H12.25V3.21094C12.25 3.04688 12.168 2.88281 12.0312 2.74609Z"
                  fill="#BFC6D6"
                />
              </svg>
            </button>
          </div>
        </div>
      </div>

      <pre {...props} className="z-0 !m-0 !pl-4 dark:bg-gray-100">
        <div className="sm:px-2 pt-10 group-[.code-header-hidden]:pt-0">
          {children}
        </div>
      </pre>
    </div>
  );
}

MDXPre.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node.isRequired,
  raw: PropTypes.string.isRequired,
  "data-language": PropTypes.string,
  "data-title": PropTypes.string,
  "data-raw": PropTypes.string,
};

MDXPre.defaultProps = {
  "data-language": "shell",
};
